import { Question } from '../types/qa';

export const mockQuestions: Question[] = [
  {
    id: '1',
    title: 'Understanding HSV-2 Transmission Rates',
    content: 'Can someone explain the transmission rates of HSV-2 with and without protection?',
    authorId: 'user1',
    isAnonymous: false,
    category: 'medical',
    status: 'answered',
    votes: 32,
    createdAt: new Date(Date.now() - 86400000).toISOString(),
    updatedAt: new Date(Date.now() - 86400000).toISOString(),
  },
  {
    id: '2',
    title: 'Managing First Outbreak Symptoms',
    content: 'Recently diagnosed and experiencing my first outbreak. What should I expect and how can I manage the symptoms?',
    authorId: 'user2',
    isAnonymous: true,
    category: 'medical',
    status: 'open',
    votes: 28,
    createdAt: new Date(Date.now() - 172800000).toISOString(),
    updatedAt: new Date(Date.now() - 172800000).toISOString(),
  },
  {
    id: '3',
    title: 'Experience with Suppressive Therapy',
    content: 'Has anyone tried daily suppressive therapy? What was your experience?',
    authorId: 'user3',
    isAnonymous: false,
    category: 'medical',
    status: 'answered',
    votes: 45,
    createdAt: new Date(Date.now() - 259200000).toISOString(),
    updatedAt: new Date(Date.now() - 259200000).toISOString(),
  },
  {
    id: '4',
    title: 'HSV-1 vs HSV-2: Key Differences',
    content: 'What are the main differences between HSV-1 and HSV-2 in terms of symptoms and management?',
    authorId: 'user4',
    isAnonymous: true,
    category: 'medical',
    status: 'open',
    votes: 39,
    createdAt: new Date(Date.now() - 345600000).toISOString(),
    updatedAt: new Date(Date.now() - 345600000).toISOString(),
  },
  {
    id: '5',
    title: 'Tips for Disclosing to Long-term Partners',
    content: 'Need advice on how to tell my long-term partner about my recent diagnosis...',
    authorId: 'user5',
    isAnonymous: true,
    category: 'relationships',
    status: 'open',
    votes: 52,
    createdAt: new Date(Date.now() - 432000000).toISOString(),
    updatedAt: new Date(Date.now() - 432000000).toISOString(),
  },
  {
    id: '6',
    title: 'Trigger Factors for Outbreaks',
    content: 'What are common triggers that can cause herpes outbreaks? How can they be avoided?',
    authorId: 'user6',
    isAnonymous: false,
    category: 'medical',
    status: 'answered',
    votes: 41,
    createdAt: new Date(Date.now() - 518400000).toISOString(),
    updatedAt: new Date(Date.now() - 518400000).toISOString(),
  },
  {
    id: '7',
    title: 'Success Stories in Long-term Relationships',
    content: 'Would love to hear positive experiences from those in successful relationships...',
    authorId: 'user7',
    isAnonymous: false,
    category: 'relationships',
    status: 'answered',
    votes: 87,
    createdAt: new Date(Date.now() - 691200000).toISOString(),
    updatedAt: new Date(Date.now() - 691200000).toISOString(),
  },
  {
    id: '8',
    title: 'Asymptomatic Shedding Explained',
    content: 'Can someone explain what asymptomatic shedding is and how it affects transmission risk?',
    authorId: 'user8',
    isAnonymous: false,
    category: 'medical',
    status: 'open',
    votes: 34,
    createdAt: new Date(Date.now() - 777600000).toISOString(),
    updatedAt: new Date(Date.now() - 777600000).toISOString(),
  },
  {
    id: '9',
    title: 'Latest Research on Herpes Treatments',
    content: 'What are the newest treatments or research developments for herpes management?',
    authorId: 'user9',
    isAnonymous: true,
    category: 'medical',
    status: 'open',
    votes: 56,
    createdAt: new Date(Date.now() - 864000000).toISOString(),
    updatedAt: new Date(Date.now() - 864000000).toISOString(),
  },
  {
    id: '10',
    title: 'Impact on Pregnancy and Planning',
    content: 'Questions about HSV and pregnancy planning...',
    authorId: 'user10',
    isAnonymous: false,
    category: 'medical',
    status: 'answered',
    votes: 72,
    createdAt: new Date(Date.now() - 950400000).toISOString(),
    updatedAt: new Date(Date.now() - 950400000).toISOString(),
  },
  {
    id: '11',
    title: 'Herpes and Immune System Health',
    content: 'How does having herpes affect the immune system? What can we do to maintain good immune health?',
    authorId: 'user11',
    isAnonymous: false,
    category: 'medical',
    status: 'open',
    votes: 43,
    createdAt: new Date(Date.now() - 1036800000).toISOString(),
    updatedAt: new Date(Date.now() - 1036800000).toISOString(),
  },
  {
    id: '12',
    title: 'Antiviral Medication Options',
    content: 'What are the different antiviral medications available for herpes? What are their pros and cons?',
    authorId: 'user12',
    isAnonymous: true,
    category: 'medical',
    status: 'answered',
    votes: 65,
    createdAt: new Date(Date.now() - 1123200000).toISOString(),
    updatedAt: new Date(Date.now() - 1123200000).toISOString(),
  }
];